document.addEventListener('DOMContentLoaded', function() {
    // Tab description snippets code
    const tabs = document.querySelectorAll('.tab__list');
    const tabContents = document.querySelectorAll('.tab__content');
    if (tabs.length > 0 && tabContents.length > 0) {
        tabs[0].classList.add('active');
        tabContents[0].classList.add('active');
    }
    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            const contentId = this.dataset.contentId;
            const content = document.getElementById(contentId);
            tabContents.forEach(function(content) {
                content.classList.remove('active');
            });
            tabs.forEach(function(tab) {
                tab.classList.remove('active');
            });
            this.classList.add('active');
            content.classList.add('active');
        });
    });
    if (window.location.hash) {
        history.replaceState(null, null, window.location.pathname + window.location.search);
    }
    const faqTab = document.querySelector('.custom-tab.content--tab4');
    if (faqTab) {
        faqTab.addEventListener('click', function() {
            if (window.location.hash) {
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }
        });
    }

    // Header section some js
    const headerMenu = document.querySelector("details.menu-drawer-container");
    const headerMenuSummary = document.querySelector("details.menu-drawer-container summary");
    if (headerMenu && headerMenuSummary) {
        headerMenuSummary.addEventListener("click", function() {
            const isOpen = headerMenu.hasAttribute("open");
            headerMenuSummary.setAttribute("aria-expanded", String(!isOpen));
        });
    }

    // Footer section code 
    const categories = document.querySelectorAll(".footer__blocks-wrapper .footer-block");

    categories.forEach(function(footerCategory) {
        const catHeading = footerCategory.querySelector('h2.footer-block__heading');
        const footerItems = footerCategory.querySelector('.footer-block__details-content');

        if (!catHeading || !footerItems) return;

        catHeading.addEventListener('click', function() {
            if (window.innerWidth <= 749) {
                footerItems.classList.toggle('active');
                const svgArrow = catHeading.querySelector('svg');
                svgArrow?.classList.toggle('rotated');
            }
        });
    });

// =================for footer subscription message==================
   const message = document.querySelector('.newsletter-form__message');

    
    if (message) {
      setTimeout(() => {
        message.style.display = 'none';
      }, 5000);
    }
  
// ================================end==========================

});

